<template>

    <div class="prop-list">
        <div class="prop-item" v-for="(value, label, index) in properties" :key="'prop-' + index">
            <div class="label">{{ label }}</div>
            <div v-if="value !== null" class="value">{{ value }}</div>
            <div v-else class="value text-muted">Unknown</div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .prop-list {
        display: grid;
        gap: 10px;
    }

    .prop-item {
        display: grid;
        gap: 15px;
        grid-auto-columns: 160px 1fr;
        grid-auto-flow: column;
        .label {
            @include font-medium(13px);
            color: $color-text-secondary;
        }
        .value {
            @include font-medium(13px);
            color: $color-text;
        }
    }

</style>

<script>

export default {

    props: {
        properties: {
            type: Object,
            required: true,
        },
    },

}

</script>
